import _ from 'lodash';
import { Configure, connectHits, connectStateResults, InstantSearch } from 'react-instantsearch-dom';
import { connect } from 'react-redux';
import { Container } from '@mui/material';
import algoliasearch from 'algoliasearch';
import React from 'react';
import Router from 'next/router';

import { BODY_STYLE_KEYS, LIFESTYLE_PREFERENCES, PAGE_SLUGS, SECTION_HANDLES } from '@/constants';
import { Box, Col, Row } from '@/components/grid';
import { buildContentMatrixQuery, fetch, getDidYouKnowTips } from '@/utils/api';
import { priceRangeSliderMarks } from '@/components/discovery-questions-input/utils/price-range-slider-marks';
import { transformContentMatrix } from '@/utils/transform';
import CardListing from '@/components/card-listing';
import CuratedFilterSuggestions from '@/components/curated-filter-suggestions';
import DidYouKnowCallout from '@/components/did-you-know-callout';
import DiscoveryFilter from '@/components/discovery-filter';
import Layout from '@/components/layout';
import PageHeaderMatrix from '@/components/page-header-matrix';
import { getIsDefaultFilterState } from '@/utils/get-is-default-filter-state';
import { getVehicleImages } from '@/utils/get-vehicle-image/index';
import { withAppProps, withAppProviders } from '@/utils/withAppProps';
import { buildPowerTypeFilter } from '@/components/discovery-filter/utils';
import { type Dispatch, type RootState } from '@/app-state/store';

const searchClient = algoliasearch(
  `${process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID}`,
  `${process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY}`,
  {}
);

const pageTitle = 'Results';
const breadcrumbs = {
  title: pageTitle,
  ancestors: [{ title: 'Search', url: '/' }],
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'didYouKnowTips' does not exist on type 'HitsProvided<BasicDoc>'.
const ConnectedCardListings = connectHits(({ didYouKnowTips, hits }) => {
  if (_.isEmpty(hits)) {
    return null;
  }

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Operator '>' cannot be applied to types 'string' and 'number'.
  const allowedCars = _.filter(hits, ({ maxPrice, minPrice }) => maxPrice > 0 && minPrice > 0);

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicles' implicitly has an 'any' type.
  const cutOutDuplicateMakeModels = (vehicles) => {
    const vehicleGroups = {};
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Variable 'trimmedVehicles' implicitly has type 'any[]' in some locations where its type cannot be determined.
    const trimmedVehicles = [];
    _.forEach(vehicles, (vehicle) => {
      const key = `${vehicle.model}_${vehicle.make}`;
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
      vehicleGroups[key] = vehicleGroups[key] || [];
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
      vehicleGroups[key].push(vehicle);
    });

    _.forEach(vehicleGroups, (group) => {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'length' does not exist on type 'never'.
      const pick = group.length > 1 ? _.last(_.sortBy(group, ['year'])) : _.head(group);
      trimmedVehicles.push(pick);
    });

    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Variable 'trimmedVehicles' implicitly has an 'any[]' type.
    return trimmedVehicles;
  };

  let cars = _.map(allowedCars, (hit) => ({
    ...hit,
    newPrice: hit.newPrice,
    priceRange: { low: hit.privateMinPrice, high: hit.privateMaxPrice },
    image: hit.image || undefined,
  }));

  cars = cutOutDuplicateMakeModels(cars);
  cars = getVehicleImages(cars);

  const primaryCars = _.take(cars, 4);
  const remainingCars = _.pullAll(cars, primaryCars);
  const secondaryCars = _.takeRight(remainingCars, 32);

  const didYouKnowColWidth = { xs: 12, sm: 11, lg: 10, xl: 9 };
  const didYouKnowColOffset = [0 / 12, 0.5 / 12, 0.5 / 12, 1 / 12, 1.5 / 12];

  return (
    <>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ title: string; intro: string; cars: { newPrice: string; priceRange: { low: string; high: string; }; image: string | undefined; objectID: string; _highlightResult: { [x: string]: HighlightResultPrimitive | undefined; }; }[]; }' is not assignable to type 'Pick<{ cars: any; gtmEvent?: null | undefined; hasShowMoreButton?: boolean | undefined; intro?: null | undefined; onShowMoreClick?: ((...args: any[]) => void) | undefined; title?: null | undefined; }, "title" | ... 3 more ... | "onShowMoreClick">'. */}
      <CardListing
        {...{
          title: 'Top picks for you',
          intro: 'Based on important safety criteria, consider these options when looking to buy a safe car.',
          cars: primaryCars,
        }}
      />
      <Container maxWidth="xl">
        <Box mt={{ xs: 2, sm: 2, md: 3, lg: 4 }} mb={{ xs: 6, sm: 6, md: 9, lg: 12 }}>
          <Row>
            <Col width={didYouKnowColWidth} offset={didYouKnowColOffset}>
              <DidYouKnowCallout {...{ didYouKnowTips }} />
            </Col>
          </Row>
        </Box>
      </Container>
      {!_.isEmpty(secondaryCars) && (
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ title: string; cars: { newPrice: string; priceRange: { low: string; high: string; }; image: string | undefined; objectID: string; _highlightResult: { [x: string]: HighlightResultPrimitive | undefined; }; }[]; }' is not assignable to type 'Pick<{ cars: any; gtmEvent?: null | undefined; hasShowMoreButton?: boolean | undefined; intro?: null | undefined; onShowMoreClick?: ((...args: any[]) => void) | undefined; title?: null | undefined; }, "title" | ... 3 more ... | "onShowMoreClick">'.
        <CardListing
          {...{
            title: 'More cars that match your needs',
            cars: secondaryCars,
          }}
        />
      )}
    </>
  );
});

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'allSearchResults' implicitly has an 'any' type.
const NoResultsMessage = ({ allSearchResults, isSearching }) => {
  if (allSearchResults === null) {
    return null;
  }
  if (!isSearching && _.isEmpty(allSearchResults.hits)) {
    return <Container maxWidth="xl">No vehicles found for the specified criteria</Container>;
  }
  return null;
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'selectedPriceRange' implicitly has an 'any' type.
const buildQuery = (selectedPriceRange) => {
  /*
    Refining on price range isn't possible using InstantSearch's refine function.
    The `connectRange` does allow you to create a slider so you can refine on a field by a selected min and max value.
    But the price range as stored is 2 fields. You'd need to compare the selected min and max value against the min price and max price fields, which isn't supported.
    Instead we build our own filter string below.
  */
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
  const minPriceIsDefaultValue = selectedPriceRange[0] === _.first(priceRangeSliderMarks).value;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
  const maxPriceIsDefaultValue = selectedPriceRange[1] === _.last(priceRangeSliderMarks).value;
  const minPriceQuery = maxPriceIsDefaultValue ? '' : `minPrice <= ${selectedPriceRange[1]}`;
  const maxPriceQuery = minPriceIsDefaultValue ? '' : `maxPrice >= ${selectedPriceRange[0]}`;
  let priceQuery = minPriceQuery || maxPriceQuery;
  if (minPriceQuery && maxPriceQuery) {
    priceQuery = `${minPriceQuery} AND ${maxPriceQuery}`;
  }

  return _.isEmpty(priceQuery) ? `isRecommendable:true` : [`isRecommendable:true`, priceQuery].join(' AND ');
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'filterState' implicitly has an 'any' type.
const updateUrlFromReduxState = (filterState) => {
  const { pPlaterApproved, safeCarsForFamilies } = LIFESTYLE_PREFERENCES;
  const {
    selectedPriceRange,
    selectedBodyStyles,
    selectedLifestyles,
    selectedMakes,
    selectedSafetyFeatures,
    selectedStarRatings,
    selectedYearRange,
    selectedPowerTypes,
  } = filterState;

  const queryObj = {
    price: selectedPriceRange.join(),
    ...(selectedBodyStyles.length && !_.includes(selectedBodyStyles, BODY_STYLE_KEYS.all)
      ? { bodyStyle: selectedBodyStyles.join() }
      : {}),
    ...(selectedLifestyles && _.includes(selectedLifestyles, pPlaterApproved) ? { pPlaterApproved: true } : {}),
    ...(selectedLifestyles && _.includes(selectedLifestyles, safeCarsForFamilies) ? { safeCarsForFamilies: true } : {}),
    ...(selectedMakes.length ? { makes: selectedMakes.join() } : {}),
    ...(selectedSafetyFeatures.length ? { safetyFeatures: selectedSafetyFeatures.join() } : {}),
    ...(selectedStarRatings.length
      ? { starRating: _.map(selectedStarRatings, (starRating) => _.kebabCase(starRating)).join() }
      : {}),
    ...(selectedYearRange.length ? { year: selectedYearRange.join() } : {}),
    ...(selectedPowerTypes.length ? { powerPlantType: selectedPowerTypes.join() } : {}),
  };

  const searchParams = new URLSearchParams(Object.entries(queryObj));

  Router.push(`/results?${searchParams.toString()}`, undefined, { shallow: true });
};

const ConnectedNoResultsMessage = connectStateResults(NoResultsMessage);
const Results = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'contentMatrices' implicitly has an 'any' type.
  contentMatrices,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'didYouKnowTips' implicitly has an 'any' type.
  didYouKnowTips,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filterActions' implicitly has an 'any' type.
  filterActions,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filterState' implicitly has an 'any' type.
  filterState,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'makes' implicitly has an 'any' type.
  makes,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'safetyFeatures' implicitly has an 'any' type.
  safetyFeatures,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'removeFromCompare' implicitly has an 'any' type.
  removeFromCompare,
}) => {
  const { selectedBodyStyles, selectedMakes, selectedPriceRange, selectedYearRange, selectedPowerTypes } = filterState;

  // This is the state that will be used to search the algolia index
  const searchState = {
    range: {
      year: {
        min: selectedYearRange[0],
        max: selectedYearRange[1],
      },
    },
    refinementList: {
      makeId: selectedMakes,
      derivedBodyStyle: selectedBodyStyles,
      // For power types, we expand the aggregated values (Hybrid, Electric) into a list of specific power types
      // eg. Hybrid -> [Mild Hybrid, Hybrid, Plug-in Hybrid]
      powerPlantType: buildPowerTypeFilter(selectedPowerTypes),
    },
  };

  let { pageHeaderMatrix } = contentMatrices[0];
  pageHeaderMatrix = transformContentMatrix(pageHeaderMatrix);

  React.useEffect(() => {
    updateUrlFromReduxState(filterState);
  }, [filterState]);

  return (
    <Layout {...{ removeFromCompare }}>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'elementMapping' is missing in type '{ blocks: any; breadcrumbs: { title: string; ancestors: { title: string; url: string; }[]; }; search: true; }' but required in type 'PageHeaderMatrixProps'. */}
      <PageHeaderMatrix blocks={pageHeaderMatrix} breadcrumbs={breadcrumbs} search />
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
      <InstantSearch {...{ searchClient, searchState, indexName: process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME }}>
        <Configure filters={buildQuery(selectedPriceRange)} hitsPerPage={36} />
        <DiscoveryFilter
          {...{
            filterActions,
            filterState,
            makes,
            safetyFeatures,
          }}
        />
        {getIsDefaultFilterState(filterState) && <CuratedFilterSuggestions />}
        <ConnectedCardListings {...{ didYouKnowTips }} />
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'isSearching' is missing in type '{}' but required in type 'Readonly<Omit<{ allSearchResults: any; isSearching: any; }, StateResultsProvided<BasicDoc>>>'. */}
        <ConnectedNoResultsMessage />
      </InstantSearch>
    </Layout>
  );
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'preview' implicitly has an 'any' type.
const getServerSideProps = withAppProps(async ({ preview, previewData }) => {
  const contentMatrixQuery = buildContentMatrixQuery(
    {
      section: SECTION_HANDLES.RESULTS,
      slug: PAGE_SLUGS.RESULTS,
    },
    true,
    false
  );

  const dropdownQuery = `
  {
    safetyFeatures: entries(type: "tacSafetyFeatures") {
      ... on tacSafetyFeatures_tacSafetyFeatures_Entry {
        id: tacFeatureCode
        label: title
      }
    }
    makes: entries(type: "make") {
      ... on vehicles_make_Entry {
        id: makeId
      }
    }
  }
  `;

  const contentMatrixResponse = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: contentMatrixQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );

  const dropdownData = await fetch(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object literal may only specify known properties, and 'query' does not exist in type '{ method: string; }'.
    { query: dropdownQuery },
    { params: { token: preview ? previewData?.previewToken : undefined } }
  );

  const [didYouKnowTips] = await Promise.all([getDidYouKnowTips()]);

  return {
    props: {
      contentMatrices: contentMatrixResponse.data.data.entries,
      makes: dropdownData.data.data.makes,
      safetyFeatures: dropdownData.data.data.safetyFeatures,
      didYouKnowTips,
    },
  };
});

const mapState = (state: RootState) => ({
  filterState: {
    selectedBodyStyles: state.filters.selectedBodyStyles,
    selectedLifestyles: state.filters.selectedLifestyles,
    selectedMakes: state.filters.selectedMakes,
    selectedPriceRange: state.filters.selectedPriceRange,
    selectedSafetyFeatures: state.filters.selectedSafetyFeatures,
    selectedStarRatings: state.filters.selectedStarRatings,
    selectedYearRange: state.filters.selectedYearRange,
    selectedPowerTypes: state.filters.selectedPowerTypes,
    uiSelectedPriceRange: state.filters.uiSelectedPriceRange,
    uiSelectedYearRange: state.filters.uiSelectedYearRange,
  },
});

const mapDispatch = (dispatch: Dispatch) => ({
  filterActions: {
    addBodyStyle: dispatch.filters.addBodyStyle,
    addLifestyle: dispatch.filters.addLifestyle,
    addMake: dispatch.filters.addMake,
    addSafetyFeature: dispatch.filters.addSafetyFeature,
    addStarRating: dispatch.filters.addStarRating,
    addPowerType: dispatch.filters.addPowerType,
    removeBodyStyle: dispatch.filters.removeBodyStyle,
    removeLifestyle: dispatch.filters.removeLifestyle,
    removeMake: dispatch.filters.removeMake,
    removeSafetyFeature: dispatch.filters.removeSafetyFeature,
    removeStarRating: dispatch.filters.removeStarRating,
    removePowerType: dispatch.filters.removePowerType,
    reset: dispatch.filters.reset,
    resetSelectedPriceRange: dispatch.filters.resetSelectedPriceRange,
    resetSelectedYearRange: dispatch.filters.resetSelectedYearRange,
    updateLifestyles: dispatch.filters.updateLifestyles,
    updateMakes: dispatch.filters.updateMakes,
    updateSafetyFeatures: dispatch.filters.updateSafetyFeatures,
    updateSelectedBodyStyles: dispatch.filters.updateSelectedBodyStyles,
    updateSelectedPriceRange: dispatch.filters.updateSelectedPriceRange,
    updateSelectedYearRange: dispatch.filters.updateSelectedYearRange,
    updateStarRatings: dispatch.filters.updateStarRatings,
    updateUiSelectedPriceRange: dispatch.filters.updateUiSelectedPriceRange,
    updateUiSelectedYearRange: dispatch.filters.updateUiSelectedYearRange,
    updatePowerTypes: dispatch.filters.updatePowerTypes,
  },
});

export default withAppProviders(connect(mapState, mapDispatch)(Results));
export { getServerSideProps };
